import { render, staticRenderFns } from "./texting-list.vue?vue&type=template&id=b3f9ee18&scoped=true"
import script from "./texting-list.vue?vue&type=script&lang=js"
export * from "./texting-list.vue?vue&type=script&lang=js"
import style0 from "./texting-list.vue?vue&type=style&index=0&id=b3f9ee18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f9ee18",
  null
  
)

export default component.exports